<mpro-modal
  class="export-modal"
  *ngIf="isModalOpen"
  title="Export data to file"
  titleInfo="Select regions, countries and date range."
  [(open)]="isModalOpen"
  (openChange)="onModalClose()"
>
  <mpro-loading *ngIf="isExporting"></mpro-loading>
  <mpro-categories-switch class="mt-4"></mpro-categories-switch>
  <div class="row modal-body-wrapper">
    <mpro-country-and-region-selector
      class="col-6"
      [allowMultiSelect]="true"
      [systemRegions]="authResources.regions"
      [systemCountries]="authResources.countries"
      (selectionChanged)="onCountryAndRegionChange($event)"
      [filters]="dataFilters"
      [permanentlyOpened]="true"
      [doNotShowSubnational]="true"
      [hideNewRegionButton]="true"
      [noSubscriptions]="true"
      [export]="true"
    >
    </mpro-country-and-region-selector>
    <div class="col-6">
      <div class="right-dropdowns-wrapper flex space-between">
        <mpro-nested-dropdown
          *ngIf="isCategoriesEnabled"
          [ngClass]="getCategoryValue() ? '' : 'inputError'"
          [placeholder]="'Pick a category'"
          [title]="'Categories'"
          [options]="categoriesList"
          (selectionChanged)="onCategoryChange($event.value)"
          [inputValue]="getCategoryValue()"
          [error]="!getCategoryValue()"
          [bgColor]="'#EEF4FF'"
          [bgColorHover]="'#E3EBFF'"
          [dark]="true"
          [multiSelect]="true"
        >
        </mpro-nested-dropdown>
        <mpro-age-group-selector
          *ngIf="
            !(authService.permissions$ | async)?.isGenerationsAvailable;
            else ageGenerations
          "
          [inputValue]="allAgeGroupsLabel"
          [selectedAgeGroups]="selectedAgeGroups"
          [userGroups]="customAgeGroups"
          [systemGroups]="authResources.ageGroups"
          (multiItemSelection)="ageGroupChanged($event)"
          [hideNew]="true"
          [multiSelect]="true"
        >
        </mpro-age-group-selector>
        <ng-template #ageGenerations>
          <mpro-age-generations-selector
            class="col-4"
            [multiSelect]="true"
            [selectedAgeGroups]="selectedAgeGroups"
            [selectedGenerations]="selectedGenerations"
            (multiItemValueChanged)="ageGenerationChanged($event)"
            [hideGenerations]="!!dataFilters.regionSelection.isCitySelected()"
          >
          </mpro-age-generations-selector>
        </ng-template>
        <mpro-multiselect-dropdown
          *ngIf="!isCategoriesEnabled"
          class="gender"
          [inputValues]="selectedGenders"
          [title]="'Gender'"
          [options]="authResources.genders"
          (selectionChanged)="genderChanged($event)"
        >
        </mpro-multiselect-dropdown>
        <mpro-spending-group-selector
          [inputValue]="allSpendingGroupsLabel"
          [selectedSpendingGroups]="selectedSpendingGroups"
          [userGroups]="customSpendingGroups"
          [multiSelect]="true"
          [systemGroups]="
            systemGroupsService.groupedSpendingGroups(
              authResources.spendingGroups
            )
          "
          (multiItemSelection)="spendingGroupChanged($event)"
          [hideNew]="true"
        >
        </mpro-spending-group-selector>
      </div>
      <div
        class="pick-category-notification"
        *ngIf="isCategoriesEnabled && !getCategoryValue()"
      >
        <fa-icon [icon]="faWarning"></fa-icon>
        Please select a category before you export or turn off the category
        data.
      </div>
      <mpro-button-group
        class="col-12 currency mt-2"
        title="Currency View"
        [dark]="false"
      >
        <ng-container *ngFor="let b of currencyView">
          <button
            class="mpro-btn"
            color="blue"
            hue="500"
            mproButtton="secondary"
            [selected]="b.value === selectedCurrencyView"
            (click)="onCurrencyViewChange(b.value)"
          >
            {{ b.name }}
          </button>
        </ng-container>
      </mpro-button-group>
      <div>
        <h5 class="range-title">Date Range</h5>
      </div>
      <mpro-range-slider
        *ngIf="renderSliderAndMap"
        [doubleSlider]="true"
        [input]="sliderInput"
        (valueChanged)="sliderChanged($event)"
        [min]="startYear"
        [max]="endYear"
        [labelGap]="2"
        [minInterval]="1"
        [dynamicRange]="true"
        [clickableTicks]="true"
        (errorChanged)="onSliderError($event)"
        [customSteps]="(customSteps | async) || []"
      >
      </mpro-range-slider>
      <mpro-alert
        *ngIf="sliderError"
        [type]="'error'"
        [message]="sliderError"
      ></mpro-alert>
      <mpro-export-data-map
        (countrySelected)="mapSelectionChanged($event)"
        (countryDeselected)="mapSelectionChanged($event)"
        *ngIf="renderSliderAndMap"
      ></mpro-export-data-map>
      <div class="flex justify-content-end mt-2">
        <div class="export-container">
          <label> Select a delivery method </label>
          <div class="flex">
            <button
              class="mpro-btn mpro-btn-secondary download-button"
              (click)="onExportData(false)"
              [disabled]="isExportProhibited()"
            >
              <fa-icon [icon]="faEmail"></fa-icon>
              EMAIL
            </button>
            <button
              class="mpro-btn mpro-btn-primary download-button"
              (click)="onExportData(true)"
              [disabled]="isExportProhibited()"
            >
              <fa-icon [icon]="faDownload"></fa-icon>
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mpro-modal
    class="export-success"
    [(open)]="exportModal.isOpen"
    (openChange)="onExportModalClose()"
  >
    <fa-icon
      [icon]="exportModal.isDownload ? faDownload : faEmail"
      class="green"
    ></fa-icon>
    <h4>Export data to file</h4>
    <p>{{ exportModal.exportMessage }}</p>
    <button
      (click)="onExportModalClose()"
      class="mpro-btn m-auto"
      textColor="gray"
      hue="300"
      color="blue"
      mproButtton="primary"
    >
      OK
    </button>
  </mpro-modal>
</mpro-modal>
